import React, { Component } from 'react';
import { Col, Row, Badge } from 'react-bootstrap';

import '../Styles.css';

import ComprobanteStatus from './ComprobanteStatus';
import SingleComprobanteActions from './SingleComprobanteActions';
import ComprobanteCancelacionStatus from './ComprobanteCancelacionStatus';

class ComprobanteStatusInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Row className="mt-3 mb-4">
        <Col xs={ 12 } sm={ 12 } md={ 8 } className="mb-2">
          <div className="d-inline-block mr-3">
            <span className="text-muted">Tipo:</span>
            <br/>
            <Badge pill variant="info">
              { data.tipo || '...' }
            </Badge>
          </div>

          <div className="d-inline-block mr-3">
            <span className="text-muted">Ambiente:</span>
            <br/>
            <Badge pill variant="warning">
              { data.live !== undefined ? (data.live ? 'Producción' : 'Test') : '...' }
            </Badge>
          </div>

          <div className="d-inline-block mr-3">
            <span className="text-muted">Status:</span>
            <br/>
            <ComprobanteStatus status={ data.status } />
          </div>

          { data.cancelacion_status !== null && (
            <div className="d-inline-block mr-3">
              <span className="text-muted">Status Cancelación:</span>
              <br/>
              <ComprobanteCancelacionStatus
                status={ data.cancelacion_status }
                cancelacion_comentario={ data.cancelacion_comentario }
              />
            </div>
          )}
        </Col>
        <Col xs={ 12 } sm={ 12 } md={ 4 } className="text-right">
          <SingleComprobanteActions data={ data } />
        </Col>
      </Row>
    )
  }
}

export default ComprobanteStatusInfo;